
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Kopfschmerzen können Zeichen einer ernsten Erkrankung sein. Fieber
beispielsweise kann auf eine Infektion hindeuten. Ein nie gekannter Kopfschmerz
sollte dringend ärztlich abgeklärt werden, ebenso, wenn sich die «gewohnten»
Kopfschmerzen aufs Mal ändern. Die Liste der Erkrankungen, die zu Kopfschmerzen
führen können, ist lang: Schlafstörungen, nächtliches Zähneknirschen, erhöhter
Augendruck, Nasennebenhöhlenentzündungen, Bluthochdruck, Arterienentzündungen,
Gefässfehlbildungen und vieles mehr.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;